import React from 'react';
import { motion } from 'framer-motion';
import { T, Lang } from '../lib/i18n';
import { HexagonBg } from './HexagonBg';
export function Process({
  lang
}: {
  lang: Lang;
}) {
  const t = T[lang].process;
  const steps = [t.s1, t.s2, t.s3, t.s4, t.s5];
  return <section id="proceso" className="bg-brand-bg-subtle py-24 px-4 md:px-8 relative overflow-hidden" data-id="element-355">
      <HexagonBg data-id="element-356" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-357">
        <div className="text-center mb-20" data-id="element-358">
          <div className="inline-block bg-brand-blue-primary/10 text-brand-blue-primary text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-359">
            {t.tag}
          </div>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl text-brand-navy-dark mb-4" data-id="element-360">
            {t.h2_1}
            <span className="bg-gradient-brand bg-clip-text text-transparent" data-id="element-361">
              {t.h2_2}
            </span>
          </h2>
          <p className="text-brand-text-muted max-w-xl mx-auto text-lg" data-id="element-362">
            {t.subtitle}
          </p>
        </div>

        <div className="relative" data-id="element-363">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-7 left-[10%] right-[10%] h-0.5 bg-brand-blue-primary/20 z-0" data-id="element-364"></div>

          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 md:gap-4 relative z-10" data-id="element-365">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex flex-col items-center text-center w-full md:w-1/5 group" data-id="element-366">
                <div className="w-14 h-14 rounded-full bg-white border-2 border-brand-blue-primary/30 flex items-center justify-center mb-4 group-hover:bg-brand-blue-primary/10 group-hover:border-brand-blue-primary transition-all duration-300 shadow-sm relative z-10" data-id="element-367">
                  <span className="font-display font-black text-xl text-brand-blue-primary" data-id="element-368">
                    {i + 1}
                  </span>
                </div>
                <h3 className="font-display font-bold text-brand-navy-dark text-lg md:text-base lg:text-lg" data-id="element-369">
                  {step}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}